/**
 * Bomu Labs — progressive-enhancement submit handler for the homepage
 * newsletter section. Uses the exact same Shopify native customer form
 * (tag: "newsletter") as the welcome popup, so there is only one signup
 * process and no duplicate customer records are created.
 */
class BomuInlineSignup extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
        });

        if (response.ok) {
          try {
            localStorage.setItem('bomu_welcome_popup_subscribed', '1');
          } catch (e) {
            /* ignore */
          }
          const formState = this.querySelector('[data-bomu-signup-form-state]');
          const success = this.querySelector('[data-bomu-signup-success]');
          if (formState) formState.hidden = true;
          if (success) success.hidden = false;
        } else {
          form.submit();
        }
      } catch (err) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  }
}

customElements.define('bomu-inline-signup', BomuInlineSignup);
